import React from 'react';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { Button } from 'primereact/button';
import { useTranslation } from 'react-i18next';

/**
 * Tab de Anuidades do Dojo.
 * Rastreia pagamentos de anuidade por ano.
 */
export function TabGymAnnuities({ gym, onAdd, onEdit, onDelete }) {
    const { t } = useTranslation();

    const actionBody = (rowData) => (
        <>
            <Button icon="pi pi-pencil" className="p-button-rounded p-button-success mr-2"
                onClick={() => onEdit(rowData)} />
            <Button icon="pi pi-trash" className="p-button-rounded p-button-danger"
                onClick={() => onDelete(rowData)} />
        </>
    );

    return (
        <>
            <br />
            <label htmlFor="name">{gym.name}</label>
            <p></p>

            <DataTable value={gym.annuityList} responsiveLayout="scroll">
                <Column field="year" header={t('msg.jkaYear')} sortable style={{ minWidth: '2rem' }} />
                <Column field="paymentDate" header={t('msg.jkaAnnuityPaymentDate')} sortable style={{ minWidth: '2rem' }} />
                <Column body={actionBody} exportable={false} style={{ minWidth: '8rem' }} />
            </DataTable>
            <p></p>
            <Button icon="pi pi-plus-circle" iconPos="right" onClick={onAdd} />
        </>
    );
}
